











import Vue, { PropType } from "vue";

export type params = {
  a: string;
  br: string;
};

export default Vue.extend({
  name: "TextView",
  components: {},
  props: {
    content: String,
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    getParams() {
      return [...this.content.matchAll(/\[\[(.*?)\]\]/g)];
    },

    getSanitizedContent(text: string) {
      return text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    },

    fillInHtml(text: string) {
      var html: string;

      var sanitizedContent = this.getSanitizedContent(text);

      html = sanitizedContent.replace(/\[\[(.*?)\]\]/g, (replace, param) => {
        param = param.trim();
        var tag = "";

        if (param.includes("{")) {
          var json = JSON.parse(param);
          for (let i in json) {
            tag += "<" + i;
            for (let k in json[i]) {
              tag += " " + k;
              tag += '="' + json[i][k];
              tag += '"';
            }
            tag += ">";
          }
        } else {
          tag = "<" + param + ">";
        }

        return tag;
      });

      return html;
    },
  },
  computed: {
    displayHtml(): String {
      var html: string = "";

      if (this.content) {
        html = this.fillInHtml(this.content);
      }

      return html;
    },
  },
});
